import hash from 'object-hash';

import { cacheRequest, cacheResponse } from 'utility/Request/cache';
import { callApi } from 'utility/Request/callApi';

import { ApiEndpoint } from 'types/Request/endpoint';

import { CsCodeUpdateResponse } from '../types';

const fetchCsCodeUpdateData = async (
    csCode: string
): Promise<CsCodeUpdateResponse> => {
    try {
        const response = await callApi(ApiEndpoint.CsCodeUpdate, {
            requestData: {
                cs_code: csCode,
            },
        });

        return response.parsedBody ?? { status: 'error' };
    } catch (e) {
        throw new Error(e as string);
    }
};

export const getCsCodeUpdateInfo = cacheRequest(
    cacheResponse(fetchCsCodeUpdateData, hash),
    hash
);
